@if (shellState$ | async; as shellState) {
  <div
    class="flex flex-col max-h-screen max-w-screen-ssxl mx-auto relative"
    [ngClass]="{ 'h-screen': shellState.mobileMenuOpened }"
    [@blockInitialRenderAnimation]
  >
    <ss-www-promo-banner></ss-www-promo-banner>
    @if (shellState.headerContent) {
      <nav
        class="z-10 w-full max-w-[100vw] flex justify-between items-center p-4 bg-ss-black-80 flex-row h-[60px] lg:h-[80px]"
        [ngClass]="{
          'border-b border-ss-gold': isMenuOrMobileMenuOpened$ | async,
        }"
      >
        @if (headerLogo()) {
          <img
            class="w-52 aspect-[4/1]"
            [ngSrc]="headerLogo()!.id"
            [alt]="headerLogo()!.title"
            [ngClass]="{
              'mx-auto': isTicketingPage,
            }"
            fill
          />
        } @else {
          <a
            [ngClass]="{
              'mx-auto': isTicketingPage,
            }"
            class="flex items-center lg:px-16 w-fit"
            routerLink="/"
            (click)="closeAllMenus()"
          >
            <!-- eslint-disable @angular-eslint/template/prefer-ngsrc -->
            <img
              class="h-7"
              src="/assets/img/ss-logo-light.svg"
              alt="Sight and Sound Logo"
            />
          </a>
        }
        @if (!isTicketingPage) {
          <div class="flex flex-row">
            <div
              class="hidden space-x-10 lg:flex flex-row align-center items-center w-fit"
            >
              <nav aria-label="Main">
                <ul class="flex flex-row items-center space-x-10">
                  <li class="has-submenu">
                    <button
                      aria-haspopup="true"
                      [attr.aria-expanded]="
                        shellState.openedMenu === 'liveShows'
                      "
                      (click)="
                        dispatchSetMenu(
                          shellState.openedMenu === 'liveShows'
                            ? 'none'
                            : 'liveShows'
                        )
                      "
                      class="ss-header-link flex flex-row items-center"
                      [ngClass]="{
                        'ss-active-link': shellState.openedMenu === 'liveShows',
                      }"
                    >
                      LIVE ON STAGE
                      <img
                        class="ml-2"
                        [src]="
                          shellState.openedMenu === 'liveShows'
                            ? '../../../assets/icons/dropdown-up.svg'
                            : '../../../assets/icons/dropdown-down.svg'
                        "
                        alt="dropdown"
                      />
                    </button>
                  </li>
                  <li>
                    <a
                      (click)="dispatchSetMenu('none')"
                      [routerLink]="[shellState.headerContent.filmsPage?.url]"
                      class="ss-header-link"
                      >FEATURE FILMS</a
                    >
                  </li>
                  <li>
                    <a
                      (click)="dispatchSetMenu('none')"
                      [routerLink]="[shellState.headerContent.tvPage?.url]"
                      class="ss-header-link"
                      >STREAMING</a
                    >
                  </li>
                  <li>
                    <button
                      aria-haspopup="true"
                      [attr.aria-expanded]="shellState.openedMenu === 'more'"
                      class="has-submenu ss-header-link flex flex-row items-center"
                      (click)="
                        dispatchSetMenu(
                          shellState.openedMenu === 'more' ? 'none' : 'more'
                        )
                      "
                      [ngClass]="{
                        'ss-active-link': shellState.openedMenu === 'more',
                      }"
                    >
                      MORE
                      <img
                        class="ml-2"
                        [src]="
                          shellState.openedMenu === 'more'
                            ? '../../../assets/icons/dropdown-up.svg'
                            : '../../../assets/icons/dropdown-down.svg'
                        "
                        alt="dropdown"
                      />
                    </button>
                  </li>
                </ul>
              </nav>
              <ss-button
                buttonColor="principal"
                buttonStyle="filled"
                routerLink="/ticketing"
                (click)="closeAllMenus()"
              >
                GET TICKETS
              </ss-button>
            </div>
            <button
              class="lg:hidden flex flex-col items-center justify-center ml-10"
              (click)="dispatchSetMobileMenu(!shellState.mobileMenuOpened)"
            >
              @if (shellState.mobileMenuOpened === false) {
                <img
                  class="w-8 lg:hidden"
                  src="/assets/icons/hamburger.svg"
                  alt="menu"
                />
              }
              @if (shellState.mobileMenuOpened === true) {
                <img
                  src="/assets/icons/hamburger-close.svg"
                  class="lg:hidden"
                  alt="menu"
                />
              }
            </button>
            <button
              class="lg:p-2 flex flex-col items-center justify-center ml-6 lg:mx-10 relative"
              (click)="goToCart()"
            >
              <img
                class="w-5 lg:w-6 m-2"
                src="/assets/icons/cart-icon.svg"
                alt="cart"
              />
              @if (numberOfItemsInCart()) {
                <div
                  class="absolute -top-1 -right-1 lg:top-1 lg:right-1 p-1 h-4 w-4 rounded-full bg-ss-gold flex flex-col items-center justify-center"
                >
                  <div class="text-xxs font-bold mt-[2px]">
                    {{ numberOfItemsInCart() }}
                  </div>
                </div>
              }
            </button>
          </div>
        }
      </nav>
    }
    <ss-www-mobile-menu
      class="w-full flex-1 block overflow-auto overflow-x-hidden bg-[#1C1C1C] text-white relative max-h-[calc(100dvh-60px)]"
      [@enterAnimation]="!!shellState.mobileMenuOpened ? 'opened' : 'closed'"
    >
    </ss-www-mobile-menu>
    @if (
      shellState.openedMenu === 'liveShows' || shellState.openedMenu === 'more'
    ) {
      <div
        class="fixed top-0 left-0 w-full h-[100vh] bg-transparent"
        (click)="closeAllMenus()"
        aria-hidden="true"
      ></div>
    }
    <div
      [@enterAnimation]="
        shellState.openedMenu === 'liveShows' ? 'opened' : 'closed'
      "
      class="w-full"
      [cdkTrapFocus]="shellState.openedMenu === 'liveShows'"
      [cdkTrapFocusAutoCapture]="shellState.openedMenu === 'liveShows'"
    >
      <div
        class="z-20 px-32 pt-10 pb-8 w-full overflow-y-auto flex flex-row items-center bg-black text-white relative"
      >
        <button
          cdkFocusRegionStart
          class="absolute right-12 top-12"
          (click)="dispatchSetMenu('none')"
        >
          <img src="/assets/icons/close.svg" class="w-5" alt="close" />
        </button>
        <div class="w-1/2">
          <ss-www-theater-shows-list
            class="w-full h-full"
            theaterName="LANCASTER, PA"
            theater="lancaster"
            [initialFocus]="true"
          >
          </ss-www-theater-shows-list>
        </div>
        <div class="border-l-2 border-white h-52 mr-8"></div>
        <div class="w-1/2">
          <ss-www-theater-shows-list
            class="w-full h-full"
            cdkFocusRegionEnd
            theaterName="BRANSON, MO"
            theater="branson"
          >
          </ss-www-theater-shows-list>
        </div>
      </div>
    </div>
    <div
      [@enterAnimation]="shellState.openedMenu === 'more' ? 'opened' : 'closed'"
      class="overflow-y-auto lg:flex flex-col w-full bg-black hidden"
    >
      <div
        class="w-full px-32 py-16 relative max-w-screen-ssxl mx-auto"
        [cdkTrapFocus]="shellState.openedMenu === 'more'"
        [cdkTrapFocusAutoCapture]="shellState.openedMenu === 'more'"
      >
        <ng-container
          *ngTemplateOutlet="closeButton"
          cdkFocusRegionStart
        ></ng-container>
        <div class="grid grid-cols-4 gap-5">
          @for (
            link of shellState.bigImageLinks;
            track trackBigImageLink(i, link);
            let i = $index;
            let last = $last;
            let first = $first
          ) {
            <ss-www-big-image-link
              class="block"
              [ngClass]="{
                'col-span-2': i < 2,
              }"
              [image]="link.image"
              [titleText]="link.text"
              [first]="first"
              [last]="last"
              [url]="link.page?.url ?? link.url ?? '#'"
            />
          }
        </div>
      </div>
    </div>
    <ng-template #closeButton>
      <button
        class="absolute right-12 top-12"
        (click)="dispatchSetMenu('none')"
      >
        <img src="/assets/icons/close.svg" class="w-5" alt="close" />
      </button>
    </ng-template>
  </div>
}
